import { render, staticRenderFns } from "./ListProgram.vue?vue&type=template&id=051651f8&scoped=true"
import script from "./ListProgram.vue?vue&type=script&lang=js"
export * from "./ListProgram.vue?vue&type=script&lang=js"
import style0 from "./ListProgram.vue?vue&type=style&index=0&id=051651f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051651f8",
  null
  
)

export default component.exports